import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import ReadOnlyDetails from "@src/components/ReadOnlyDetails";
import { type GQLPurchaseAdminQuery } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

const PurchaseInformation: FC<PropsWithChildren<GQLPurchaseAdminQuery>> = ({ licenceAdmin }) => {
    const intl = useIntl();
    const { activatedAt, code, activeFrom, activeTill } = licenceAdmin;

    return (
        <ReadOnlyDetails title={intl.formatMessage({ id: "reviermanager.purchases.detail.title", defaultMessage: "Details zur Lizenzverlängerung" })}>
            <ReadOnlyDetailField value={code} label={intl.formatMessage({ id: "reviermanager.purchase.code", defaultMessage: "Code" })} />
            <ReadOnlyDetailField
                type="date"
                value={activatedAt}
                label={intl.formatMessage({ id: "reviermanager.camera.purchaseAt", defaultMessage: "Kaufdatum" })}
            />
            <ReadOnlyDetailField
                type="date"
                value={activeFrom}
                label={intl.formatMessage({ id: "reviermanager.camera.licence.activeFrom", defaultMessage: "Lizenz aktiviert am" })}
            />
            <ReadOnlyDetailField
                type="date"
                value={activeTill}
                label={intl.formatMessage({ id: "reviermanager.camera..licence.activeTill", defaultMessage: "Lizenz läuft ab am" })}
            />
        </ReadOnlyDetails>
    );
};
export default PurchaseInformation;
